'use client'

import { useEffect } from 'react'

import posthog from 'posthog-js'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    try {
      posthog.captureException(error, {
        name: error.name ?? 'Unknown error',
        message: error.message ?? 'No message available',
        stack: error.stack ?? 'No stack trace available',
        digest: error.digest,
        boundary: 'global-error',
      })
    } catch (captureError) {
      console.error('Failed to capture error to PostHog', captureError)
    }
  }, [error])

  return (
    <html lang="en">
      <body
        style={{
          fontFamily: 'system-ui, sans-serif',
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          color: '#1a202c',
          background: '#fff',
        }}
      >
        <h1 style={{ color: '#e53e3e', marginBottom: 16 }}>
          The app failed to load
        </h1>
        <p style={{ maxWidth: 640, textAlign: 'center', marginBottom: 16 }}>
          An error in the root layout stopped the app from rendering. Try
          reloading the page; if it keeps happening, share the details below
          with a developer.
        </p>
        <pre
          style={{
            background: '#f7fafc',
            border: '1px solid #e2e8f0',
            borderRadius: 6,
            padding: 16,
            maxWidth: 640,
            maxHeight: '40vh',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontSize: 13,
            marginBottom: 24,
            width: '100%',
          }}
        >
          {error?.message || 'No error message available'}
        </pre>
        <button
          style={{
            padding: '8px 16px',
            borderRadius: 6,
            border: '1px solid #cbd5e0',
            background: '#fff',
            cursor: 'pointer',
            fontSize: 14,
          }}
          type="button"
          onClick={() => reset()}
        >
          Try again
        </button>
      </body>
    </html>
  )
}
